<template>
  <div class="member-modal-overlay" v-if="visible">
    <div class="member-modal">
      <div class="member-modal__body text-left">
        <h3 class="member-modal__title" v-if="recipient">
          Send Request to {{ recipient.salutation }} {{ recipient.first_name }} {{ recipient.last_name }}
        </h3>
        <div class="member-modal__footer mt-4">
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label>Message</label>
              <textarea
                class="form-control member-form-textarea"
                v-validate="'required'"
                v-model="message"
                name="message"
                :class="{ 'is-invalid': errors.has('message') }"
                data-vv-as="message"
                rows="5"
              ></textarea>
              <small class="invalid-feedback" v-if="errors.has('message')">
                {{ errors.first('message') }}
              </small>
            </div>
            <div class="btn-group">
              <button
                type="button"
                @click="handleClose"
                class="btn member-modal__btn member-modal__btn--cancel"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="btn member-modal__btn member-modal__btn--confirm ml-3"
                :disabled="submitted"
              >
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendConnectionRequestModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    recipient: {
      type: Object,
      default: () => null
    },
    submitted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: ''
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.message = '';
        if (this.$validator) this.$validator.reset();
      }
    }
  },
  methods: {
    async handleSubmit() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) return;
      this.$emit('submit', this.message);
    },
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.member-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.member-modal {
  width: 100%;

  &__body {
    background: #000;
    width: 480px;
    max-width: 90vw;
    margin: 0 auto;
    border-radius: 5px;
    padding: 20px 25px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    color: #ffffff;
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
  }

  &__title {
    font-size: 20px;
    letter-spacing: 0;
    margin-bottom: 0;
  }

  &__btn {
    font-size: 16px;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    border-radius: 3px !important;
    border: none;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    &--confirm {
      background: rgba(33, 228, 0, 0.5);
      color: #fff;
      &:hover {
        background: #ffe738 !important;
        color: #22292f !important;
      }
    }

    &--cancel {
      background: rgba(255, 18, 18, 0.5);
      color: #fff;
      &:hover {
        background: #ffe738 !important;
        color: #22292f !important;
      }
    }
  }
}

.member-form-textarea {
  background: rgba(255, 255, 255, 0.1) !important;
  border: none;
  color: #fff;
}
</style>